import React from 'react';
import Select from '../Select';

const SearchSelect = (props) => {
  const {
    optionsList,
    value,
    placeholder,
    style,
    onSearch,
    onChange,
    ...rest
  } = props;
  return (
    <Select
      showSearch
      value={value}
      placeholder={placeholder}
      style={style}
      defaultActiveFirstOption={false}
      showArrow={false}
      filterOption={false}
      onSearch={onSearch}
      onChange={onChange}
      notFoundContent={null}
      optionsList={optionsList}
      {...rest}
    />
  );
};
export default SearchSelect;
